import { useEffect, useState } from "react";
import Box from "elements/Box";
import { Autocomplete, Button, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import { ApiRequest } from "GlobalFunctions";

/*=====================================================
CORRECCIONES (Temporal)
-----------------------------------------------------
Permite corregir el cliente de un pedido:
1. Selecciona la empresa (autocomplete).
2. Ingresa Código de pedido y Código de cliente.
3. Al dar "Actualizar", el backend valida ambos dentro
   de la empresa y actualiza el cliente del pedido.
=====================================================*/
export default function Corrections(props: any) {
  const { setLoading } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [companies, setCompanies] = useState<any[]>([]);
  const [selectedCompany, setSelectedCompany] = useState<any>(null);
  const [orderCode, setOrderCode] = useState<string>("");
  const [clientCode, setClientCode] = useState<string>("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setLoading(false);
    getCompanies();
  }, []);

  const getCompanies = () => {
    ApiRequest({
      url: "/companies/list",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: { full_list: true },
      setResponse: (response: any) => {
        if (response.list) {
          setCompanies(response.list);
        }
      },
    });
  };

  const canSubmit =
    !!selectedCompany &&
    orderCode.trim() !== "" &&
    clientCode.trim() !== "" &&
    !submitting;

  const handleSubmit = async () => {
    if (!selectedCompany) {
      enqueueSnackbar("Debes seleccionar una empresa", { variant: "error" });
      return;
    }
    if (orderCode.trim() === "" || clientCode.trim() === "") {
      enqueueSnackbar("Debes ingresar el código de pedido y el código de cliente", {
        variant: "error",
      });
      return;
    }

    setSubmitting(true);
    setLoading(true);

    await ApiRequest({
      url: "/corrections/updateOrderClient",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body: {
        company_id: selectedCompany.company_id,
        order_code: orderCode.trim(),
        client_code: clientCode.trim(),
      },
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar(response.message, { variant: "success" });
          setOrderCode("");
          setClientCode("");
        } else {
          enqueueSnackbar(response.message || "No se pudo actualizar el pedido", {
            variant: "error",
          });
        }
        setSubmitting(false);
        setLoading(false);
      },
    });
  };

  return (
    <div id="Corrections" className="ModuleContainer">
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Correcciones</h2>
            <span className="h2_subtitle">
              Corrige el cliente asignado a un pedido
            </span>
          </div>
        </div>

        <Box id="CorrectionsBox" className="box100">
          {/* COMPANY SELECTION */}
          <Autocomplete
            options={companies}
            getOptionLabel={(option: any) => option.company_name || ""}
            value={selectedCompany}
            onChange={(_e, newValue) => setSelectedCompany(newValue)}
            isOptionEqualToValue={(option: any, value: any) =>
              option.company_id === value.company_id
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Empresa"
                variant="outlined"
                placeholder="Buscar empresa..."
              />
            )}
            sx={{ mb: 2 }}
          />

          {/* FIELDS: only show after a company is selected */}
          {selectedCompany && (
            <>
              <TextField
                label="Código de pedido"
                variant="outlined"
                fullWidth
                value={orderCode}
                onChange={(e) => setOrderCode(e.target.value)}
                placeholder="Ej: 1024"
                sx={{ mb: 2 }}
              />

              <TextField
                label="Código de cliente"
                variant="outlined"
                fullWidth
                value={clientCode}
                onChange={(e) => setClientCode(e.target.value)}
                placeholder="Ej: C-0345"
                sx={{ mb: 2 }}
              />

              <Button
                variant="contained"
                color="primary"
                fullWidth
                disabled={!canSubmit}
                onClick={handleSubmit}
              >
                Actualizar
              </Button>
            </>
          )}
        </Box>
      </div>
    </div>
  );
}
